export type Base64FileType = 'image' | 'pdf' | 'other' | 'empty';

export function getBase64FileType(base64: string): Base64FileType {
  if (!base64.includes('base64')) {
    return 'other';
  }

  const parts = base64.split('base64,');
  const firstPart = parts[0];
  const secondPart = parts[1];

  if (!firstPart) {
    return 'other';
  }

  if (['jpg', 'jpeg', 'png', 'gif'].some((item) => firstPart.includes(item))) {
    return 'image';
  }

  if (firstPart.includes('pdf')) {
    return 'pdf';
  }

  if (!secondPart) {
    return 'empty';
  }

  return 'other';
}
